import AddresseesNotificationsReports from '../src/components/sections/AddresseesNotificationsReports';

export default AddresseesNotificationsReports;
